import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { observable, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ChannelOrigin } from "./api-interfaces/channelOrigin.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIChannelOriginService {
    
    ApiURL: string = "";
    
    constructor(private http: HttpClient, private helperService: HelperService) {
        // TODO: create environment variable
        this.ApiURL = environment.originsUrl+'ScheduleOrigins'
    }

    public getAllChannels(): Observable<ChannelOrigin[]>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.get<ChannelOrigin[]>(this.ApiURL,requestOptions);
    }

    public getChannelById(channelId): Observable<ChannelOrigin>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.get<ChannelOrigin>(this.ApiURL + "/" + channelId,requestOptions);
    }
 
}

    
